import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import NavBar from './components/NavBar';
import SideBar from './components/SideBar';
import Content from './components/Content';
import Confirmation from './components/Confirmation';
import ThankYou from './components/ThankYou';
import CollaboratorDetails from './components/CollaboratorDetails';
import NotFound from './components/NotFound';
import Footer from './components/Footer';
import { HelmetProvider } from 'react-helmet-async';

const stripePromise = loadStripe(process.env.REACT_APP_PUBLIC_KEY); // Replace with your actual publishable key

function App() {
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [confirmationData, setConfirmationData] = useState({});

  // Hook to get the current location
  const location = useLocation();

  useEffect(() => {
    // console.log("process.env.REACT_APP_PUBLIC_KEY", process.env.REACT_APP_PUBLIC_KEY);
    // console.log("location.pathname", location)
  }, []);

  const handleFormSubmit = (data) => {
    setConfirmationData(data);
    setIsConfirmationOpen(true);
  };


  return (
    <Elements stripe={stripePromise}>
      <Box>
        <NavBar />
        <Box>
          <Flex direction={{ base: 'column', md: 'row' }}>
            {/* Conditionally render the SideBar based on the current path */}
            {location.pathname === '/' && <SideBar />}
            <Box
              flex="1"
              width={{ base: '100%', md: '75%' }}
              marginTop={{ base: '1rem', md: '0' }}
              padding={{ base: '1rem', md: '2rem 1rem' }}
            >
              <Routes>
                <Route path="/" element={<Content onSubmit={handleFormSubmit} />} />
                <Route path="/thank-you" element={<ThankYou />} />
                <Route path="/specialists/:slug" element={<CollaboratorDetails />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Box>
          </Flex>
          <Confirmation
            isOpen={isConfirmationOpen}
            onClose={() => setIsConfirmationOpen(false)}
            data={confirmationData}
          />
        </Box>
        <Footer />
      </Box>
    </Elements>
  );
}

// Wrap your App component with Router
function AppWrapper() {
  return (
    <HelmetProvider>
      <Router>
        <App />
      </Router>
    </HelmetProvider>
  );
}

export default AppWrapper;
